module.exports = __webpack_public_path__ + "images/marker.f82829.png";